<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col cols="12" class="pt-3 pt-md-0 pa-0">
        <v-col cols="12" class="common-card-col">
          <v-card-title class="pa-0 ma-0">Scavenger Health</v-card-title>
        </v-col>
      </v-col>
    </v-row>
    <v-row class="common-card-row">
      <v-col cols="12" md="3" class="pr-md-3 pb-3 pb-md-0 pa-0">
        <v-col class="common-card-col" cols="12">
          <RadialChartVT
            :v-if="this.charts_mock_data && ageing"
            :title="page_content.ageing.title"
            :tooltip="page_content.ageing.tooltip"
            :chartData="ageing"
            @on-click="apply_graph_filter('Ageing', $event)"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="3" class="pr-md-3 pb-3 pb-md-0 pa-0">
        <v-col class="common-card-col" cols="12">
          <RadialChartVT
            :v-if="this.charts_mock_data && hydrogen"
            :title="page_content.hydrogen.title"
            :tooltip="page_content.hydrogen.tooltip"
            :chartData="hydrogen"
            @on-click="apply_graph_filter('Hydrogen', $event)"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="3" class="pr-md-3 pb-3 pb-md-0 pa-0">
        <v-col class="common-card-col" cols="12">
          <RadialChartVT
            :v-if="this.charts_mock_data && risk_of_overload"
            :title="page_content.risk_of_overload.title"
            :tooltip="page_content.risk_of_overload.tooltip"
            :chartData="risk_of_overload"
            @on-click="apply_graph_filter('TemperatureIssues', $event)"
          />
        </v-col>
      </v-col>
      <v-col cols="12" md="3" class="pa-0">
        <v-col class="common-card-col" cols="12">
          <RadialChartVT
            :v-if="this.charts_mock_data && asset_replacement_maintenance"
            :title="page_content.asset_replacement_maintenance.title"
            :tooltip="page_content.asset_replacement_maintenance.tooltip"
            :chartData="asset_replacement_maintenance"
            @on-click="apply_graph_filter('AssetReplacementMaintenance', $event)"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-row class="common-card-row">
      <v-col cols="12" class="pt-3 pt-md-0 pa-0 pb-3">
        <v-col cols="12" class="common-card-col">
          <PrimaryFiltersVT
            :list_filters="page_content.primary_filters"
            @filter_update="filter_list($event)"
            current_tab="All"
          />
          <DataTableVT
            :headers="page_content.assets_health_table"
            :items_list="assets"
            sort_by="AssetID"
            item_key="AssetID"
            @rowClick="open_details($event)"
            @add-to-list="watchlist_update($event)"
            :loading="is_loading"
          />
        </v-col>
      </v-col>
    </v-row>
    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        style="width: 80vw; max-height: 80vh; overflow: auto"
        color="backgroundLight"
      >
        <div class="close-btn">
          <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
            <v-icon small color="primaryGrey">close</v-icon>
          </v-btn>
        </div>
        <ScavengerHealthDetails :deviceId="deviceId" v-if="overlay_type == 'details'" />
      </v-card>
    </v-overlay>

    <v-snackbar color="borderDark" v-model="snackbar" timeout="2000">{{ error_message }}</v-snackbar>
  </v-container>
</template>

<script>
import { content } from "../../config/scavenger.js";
import RadialChartVT from "../components/RadialChartVT";
import DataTableVT from "../components/DataTableVT";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import ScavengerHealthDetails from "../views/ScavengerHealthDetails";
import { redirect_to_asset } from "../helpers/helpers";
import chart_data from "../helpers/data.js";

export default {
  name: "ScavengerHealth",
  components: {
    RadialChartVT,
    DataTableVT,
    PrimaryFiltersVT,
    ScavengerHealthDetails,
  },
  data() {
    return {
      charts_mock_data: null,
      page_content: null,
      assets: [],
      is_loading: false,
      overlay_type: "",
      snackbar: false,
      dialog: false,
      error_message: "",
    };
  },
  created() {
    this.page_content = content;
  },
  mounted() {
    this.get_device_overview();
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.overlay_type = "";
    },
    get_device_overview() {
      //API CALL WILL MAKE HERE TO GET DATA
      this.charts_mock_data = {
        ageing: [
          { name: "AcceleratedAgeing", Total: 55 },
          { name: "FutureAgeing", Total: 92 },
          { name: "Normal", Total: 853 },
        ],
        riskOfOverload: [
          { name: "RiskOfOverload", Total: 51 },
          { name: "Re-Rating", Total: 25 },
          { name: "Normal", Total: 853 },
        ],
        hydrogen: [
          { name: "HydrogenAlert", Total: 23 },
          { name: "HydrogenRateOfChangeAlert", Total: 67 },
          { name: "Normal", Total: 853 },
        ],
        asset_replacement_maintenance: [
          { name: "Replacement", Total: 32 },
          { name: "Maintenance", Total: 55 },
          { name: "TemperatureIssues", Total: 66 },
          { name: "Normal", Total: 853 },
        ],
      };
      this.assets = [
        {
          AssetID: "B24F21",
          AssetName: "Asset 1",
          Ageing: ["FutureAgeing"],
          Hydrogen: ["HydrogenAlert", "HydrogenRateOfChangeAlert"],
          RiskOfOverload: ["RiskOfOverload"],
          AssetReplacementMaintenance: ["Temperature"],
          IsWatchlisted: true,
        },
        {
          AssetID: "C83G55",
          AssetName: "Asset 2",
          Ageing: ["FutureAgeing"],
          Hydrogen: ["HydrogenRateOfChangeAlert"],
          AssetReplacementMaintenance: ["Replacement"],
          IsWatchlisted: true,
        },
        {
          AssetID: "D91H42",
          AssetName: "Asset 3",
          Hydrogen: ["HydrogenAlert"],
          AssetReplacementMaintenance: ["Replacement"],
          IsWatchlisted: true,
        },
        {
          AssetID: "E76K23",
          AssetName: "Asset 4",
          Hydrogen: ["HydrogenAlert"],
          AssetReplacementMaintenance: ["Maintenance"],
          IsWatchlisted: false,
        },
        {
          AssetID: "F34L56",
          AssetName: "Asset 5",
          Hydrogen: ["HydrogenAlert"],
          AssetReplacementMaintenance: ["Replacement"],
          IsWatchlisted: false,
        },
        {
          AssetID: "G42M98",
          AssetName: "Asset 6",
          Ageing: ["FutureAgeing", "AcceleratedAgeing"],
          Hydrogen: ["HydrogenAlert"],
          RiskOfOverload: ["ReRating"],
          IsWatchlisted: false,
        },
        {
          AssetID: "H76N23",
          AssetName: "Asset 7",
          Ageing: ["FutureAgeing", "AcceleratedAgeing"],
          IsWatchlisted: false,
        },
        {
          AssetID: "J65P47",
          AssetName: "Asset 8",
          Ageing: ["FutureAgeing", "AcceleratedAgeing"],
          IsWatchlisted: false,
        },
        {
          AssetID: "K24Q32",
          AssetName: "Asset 9",
          Ageing: ["FutureAgeing", "AcceleratedAgeing"],
          AssetReplacementMaintenance: ["Replacement", "Temperature"],
          IsWatchlisted: false,
        },
        {
          AssetID: "L54R92",
          AssetName: "Asset 10",
          Ageing: ["FutureAgeing", "AcceleratedAgeing"],
          AssetReplacementMaintenance: ["Temperature"],
          IsWatchlisted: false,
        },
      ];
    },
    format_chart_data(chart_data, config) {
      var data = [];
      var others_total = 0;
      if (chart_data) {
        data = config.data.map((currentValue) => {
          others_total = 0;
          var total = 0;
          var result = chart_data.filter((data) => {
            total = total + data.Total;
            if (
              data.name &&
              !currentValue.values &&
              data.name.toLowerCase().trim() == currentValue.value.toLowerCase().trim()
            ) {
              return true;
            } else if (data.name && !currentValue.value && currentValue.values) {
              others_total =
                others_total +
                (data.name && currentValue.values.indexOf(data.name.toLowerCase()) == -1 ? data.Total : 0);
              return true;
            } else {
              return false;
            }
          });
          var value = result[0] && result[0]["Total"];
          var final_val = currentValue.label == "Others" ? others_total : value;
          return [
            currentValue.label,
            final_val,
            {
              msg: currentValue.msg,
              title: currentValue.label,
              footer: `${this.$numberWithCommas(final_val)}(${this.$numberWithCommas(
                Math.round((final_val / total) * 10000) / 100
              )}%)`,
            },
          ];
        });
      } else {
        data = [config.header];
      }
      return data ? [config.header, ...data] : null;
    },
    async filter_list(filter) {
      console.log(filter);
    },
    async add_to_watchlist(item) {
      //API call to add to watchlist
    },
    async delete_from_watchlist(item) {
      //API call to delete from watchlist
    },
    watchlist_update(item) {
      item["IsWatchlisted"] ? this.delete_from_watchlist(item) : this.add_to_watchlist(item);
    },
    apply_graph_filter(type, val) {
      console.log(type, val);
    },
    open_details(asset) {
      if (asset.ctrlKey) return redirect_to_asset(this.$router, "scavenger_health", asset.AssetID);
      this.overlay_type = "details";
      this.deviceId = asset.AssetID;
      this.asset_detail_data = asset;
      this.dialog = true;
      this.detail_device = asset;
    },
  },
  computed: {
    ageing: function () {
      return this.charts_mock_data
        ? this.format_chart_data(this.charts_mock_data.ageing, this.page_content.ageing)
        : [];
    },
    hydrogen: function () {
      return this.charts_mock_data
        ? this.format_chart_data(this.charts_mock_data.hydrogen, this.page_content.hydrogen)
        : [];
    },
    risk_of_overload: function () {
      return this.charts_mock_data
        ? this.format_chart_data(this.charts_mock_data.riskOfOverload, this.page_content.risk_of_overload)
        : [];
    },
    asset_replacement_maintenance: function () {
      return this.charts_mock_data
        ? this.format_chart_data(
            this.charts_mock_data.asset_replacement_maintenance,
            this.page_content.asset_replacement_maintenance
          )
        : [];
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .export-div {
  top: 35px;
}
::v-deep .right-border {
  border-right: 1px solid var(--v-border-base);
}
.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}
</style>
